import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

function ActionRow(props) {
  return (
    <React.Fragment>
      <div className="sgpsTile__actionRow__main">
        <div className="sgpsTile__actionRow__label">
          {props.label}
        </div>
        <div className="sgpsTile__actionRow__description">
          {props.description}
        </div>
      </div>

      <div className="sgpsTile__actionRow__icon">
        <span className="btnlist__icon">
          {props.type === 'external' ? (
              <i className="fa fa-external-link"></i> // Icon for external page
            ) : (
              <i className="fa fa-chevron-right"></i> // Default icon
            )}
        </span>
      </div>
    </React.Fragment>
  );
}


/**
 * 
 * @param {*} props - type, label, description (optional), to (which is either a string or an object), onClick (which overrides the link if specified)
 * @returns 
 */
function TileActionRowLink(props) {
  const rootClasses = clsx({
    sgpsTile__actionRow: true,
    'sgpsTile__actionRow--selectable': true,
  });

  if (props.type === 'external') {
    return (
      <a
        href={props.to}
        onClick={props.onClick ? (e) => { e.preventDefault(); props.onClick() } : null }
        className={rootClasses}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <ActionRow {...props} />
      </a>
    );
  }

  return (
    <Link to={props.to} className={rootClasses}>
      <ActionRow {...props} />
    </Link>
  );
}

export default TileActionRowLink;
